import React, { useEffect } from 'react';
import { closeModal } from '~shared/actions/modal';
import { snakeToProperCase } from '~shared/helpers/string';
import { useAnalytics } from '~shared/hooks/useAnalytics';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import getIsModalShowing from '~shared/selectors/modal/getIsModalShowing';
import getModalProps from '~shared/selectors/modal/getModalProps';
import getModalType from '~shared/selectors/modal/getModalType';
import { useDispatchShared, useSelectorShared } from '~shared/store';
import { GetTheAppDrawer } from './GetTheAppDrawer';

export const AppModals = () => {
  const { trackEvent } = useAnalytics();
  const dispatch = useDispatchShared();
  const showing = useSelectorShared(getIsModalShowing);
  const type = useSelectorShared(getModalType);
  const props = useSelectorShared(getModalProps);

  useEffect(() => {
    if (showing && type) {
      trackEvent({
        event: EVENTS.MODAL_VIEWED,
        params: {
          origin: window.location.pathname,
          type: snakeToProperCase(type),
        },
      });
    }
  }, [trackEvent, type, showing]);

  const close = () => {
    dispatch(closeModal(type));
  };

  if (!showing) {
    return null;
  }

  switch (type) {
    case 'GET_THE_APP_DRAWER':
      return (
        <GetTheAppDrawer
          onClose={close}
          {...(props as { tempPassword: string })}
        />
      );

    default:
      return null;
  }
};
